import { ru } from './ru';
import { en } from './en';

const translations: Record<string, Record<string, string>> = { ru, en };

let currentLang = 'ru';

export function setLanguage(lang: string) {
  currentLang = lang;
}

export function getLanguage() {
  return currentLang;
}

export function t(key: string): string {
  return translations[currentLang]?.[key] ?? translations.en?.[key] ?? key;
}

export function useTranslation() {
  return { t, lang: currentLang, setLanguage };
}
